// @ts-nocheck
/* eslint-disable */
import ScenePixel from "~/scene/common/pixel";
import SceneTile from "~/scene/common/tile";
import { store } from "~/state/store";
import { CONFIG } from "~/config";

/**
 * Mercator projekce - defaultni, mapa neni otocena
 */
const SCREEN_COEFFICIENTS = new ScenePixel(1, 1);

const TILE = {
	TILE_SIZE: 256,
	QUERY: "{zoom}-{x}-{y}"
};

export default class SceneProjection {
	constructor(scene) {
		this._scene = scene;
	}

	getViewport() {
		let size = this._scene.getSize();
		let w = Math.round(size.x / 2);
		let h = Math.round(size.y / 2);
		let lb = this.pixelToCoords(new ScenePixel(-w, h)).toWGS84();
		let rt = this.pixelToCoords(new ScenePixel(w, -h)).toWGS84();

		return {
			lbx: lb[0],
			lby: lb[1],
			rtx: rt[0],
			rty: rt[1]
		};
	}

	countZoom(lenX, lenY, padding, overlap) {
		/* kolikatinu sveta potrebujeme zobrazit */
		let size = this._scene.getSize();
		let w = size.x;
		let h = size.y;

		// povolení presahu
		if (overlap > 0) {
			w = w * (1 + overlap / 100);
			h = h * (1 + overlap / 100);
		}

		// padding
		if (padding) {
			w -= (padding.left || 0);
			w -= (padding.right || 0);
			h -= (padding.top || 0);
			h -= (padding.bottom || 0);
		};

		// omezeni po nastaveni paddingu
		w = w < 0 ? size.x : w;
		h = h < 0 ? size.y : h;

		let ws = this.getWorldSize(0);
		let fracX = (360*w)/(ws.x * lenX);
		let fracY = (180*h)/(ws.y * lenY);
		let frac = Math.min(fracX, fracY);

		return Math.floor(Math.log(frac) / Math.LN2);
	}

	pixelToCoords(pixel, zoomIn) {
		const { longitude, latitude, zoom } = store.getState().map;
		const zoomValid = typeof zoomIn === "undefined" ? zoom : zoomIn;

		let abs = this.pixelToAbsolutePixel(pixel, this._scene.coordsFromWGS84(longitude, latitude), zoomValid);
		let world = this.getWorldSize(zoom);
		abs.x = this.numMod(abs.x, world.x);

		return this.unproject(abs, zoom);
	}

	/**
	 * Prevede souradnice x a na dlazdici.
	 *
	 * @param  {ScenePixel} pixel
	 * @return {Object}
	 */
	_pixelToTile(pixel, center, zoom, tileSize) {
		let abs = this.pixelToAbsolutePixel(pixel, center, zoom);
		let world = this.getWorldSize(zoom);

		if (abs.y < 0 || abs.y >= world.y) { return null; }

		return new SceneTile(zoom, tileSize, Math.floor(abs.x / tileSize), Math.floor(abs.y / tileSize));
	}

	/**
	 * Prevede souradnice x a na dlazdici.
	 *
	 * @param  {ScenePixel} pixel
	 * @return {Object}
	 */
	pixelToTile(pixel, tileSize) {
		const { longitude, latitude, zoom } = store.getState().map;

		return this._pixelToTile(pixel, this._scene.coordsFromWGS84(longitude, latitude), zoom, tileSize);
	}

	/**
	 * Prevede data dlazdice na pixel.
	 *
	 * @param  {Object} tile Data s dlazdici
	 * @param  {SceneCoords} centerArg Stred projekce
	 * @param  {Number} zoom Mercator zoom
	 * @return {Object}
	 */
	_tileToPixel(tile, centerArg, zoom) {
		let ts = tile.tileSize;
		let x = tile.x * tile.tileSize;
		let y = tile.y * tile.tileSize;
		let center = this.project(centerArg, zoom);

		let px = { x: x - center.x, y: y - center.y};
		if (SCREEN_COEFFICIENTS.x == -1) { px.x = - px.x - ts; }
		if (SCREEN_COEFFICIENTS.y == -1) { px.y = - px.y - ts; }

		return px;
	}

	/**
	 * Prevede data dlazdice na pixel.
	 *
	 * @param  {Object} tile Data s dlazdici
	 * @return {ScenePixel}
	 */
	tileToPixel(tile) {
		const { longitude, latitude, zoom } = store.getState().map;

		return this._tileToPixel(tile, this._scene.coordsFromWGS84(longitude, latitude), zoom);
	}

	coordsToPixel(coords, zoomIn) {
		const { longitude, latitude, zoom } = store.getState().map;
		const zoomValid = typeof zoomIn === "undefined" ? zoom : zoomIn;
		const abs = this.project(coords, zoomValid);

		return this.absolutePixelToPixel(abs, this._scene.coordsFromWGS84(longitude, latitude), zoomValid);
	}

	/**
	 * Prevede pixel na absolutni v zavislosti na vzdalenosti od stredu.
	 *
	 * @param  {Object} pixel Vstupni pixel
	 * @param  {Object} center Stred projekce
	 * @param  {Number} zoom Mercator zoom
	 * @return {Object} Pixel na absolutni pixel
	 */
	pixelToAbsolutePixel(pixel, center, zoom) {
		let abs = this.project(center, zoom);
		abs.x += SCREEN_COEFFICIENTS.x * pixel.x;
		abs.y += SCREEN_COEFFICIENTS.y * pixel.y;

		return abs;
	}

	absolutePixelToPixel(abs, center, zoom) {
		var abscenter = this.project(center, zoom);
		var coef = SCREEN_COEFFICIENTS;

		return new ScenePixel(coef.x*(abs.x - abscenter.x), coef.y*(abs.y - abscenter.y));
	}

	/**
	 * Ziskeni velikosti sveta v zavislosti na zoomu.
	 *
	 * @param  {Number} [zoom = 0] Vlastni zoom
	 * @return {ScenePixel}
	 */
	getWorldSize(zoom) {
		let size = Math.pow(2, zoom + 8);

		return new ScenePixel(size, size);
	}

	/**
	 * Mod cisla.
	 *
	 * @param  {Number} value Vstupni hodnota
	 * @param  {Number} modulus
	 * @return {Number}
	 */
	numMod(value, modulus) {
		let remainder = value % modulus;

		return (remainder < 0 ? remainder + modulus : remainder);
	}

	/**
	 * Prepocet souradnic na pixel.
	 *
	 * @param  {SceneCoords} coords Vstupni souradnice
	 * @param  {Number} zoom Mercator zoom
	 * @return {ScenePixel}
	 */
	project(coords, zoom) {
		let wgs = coords.toWGS84();
		let world = this.getWorldSize(zoom);

		let x = (wgs[0] + 180) / 360 * world.x;
		let y = wgs[1] * Math.PI / 180;

		let f = Math.min(Math.max(Math.sin(y), -0.9999), 0.9999);
		y = (1.0-(0.5*Math.log((1+f)/(1-f)))/Math.PI)/2 * world.y;

		return new ScenePixel(x, y);
	}

	unproject(pixel, zoom) {
		let world = this.getWorldSize(zoom);

		let lon = pixel.x * 360 / world.x - 180;
		let lat = 2 * Math.atan(Math.exp(Math.PI * (1 - 2 * pixel.y/world.y)))- Math.PI/2;
		lat = lat * 180 / Math.PI;

		return this._scene.coordsFromWGS84(lon, lat);
	}

	/**
	 * Vytvoreni dlazdic.
	 *
	 * @param {Object} argOpts Viz par radku nize
	 * @return {Array[Object]} tile, left, top, url
	 */
	createTiles(argOpts) {
		let opts = {
			url: `${CONFIG.mapserver.url}/base-m/`,
			x: 12,
			y: 50,
			z: 8,
			width: 100,
			height: 100,
			tileSize: 0
		};

		for (let key in argOpts) {
			opts[key] = argOpts[key];
		}

		let tiles = [];
		let ts = opts.tileSize || TILE.TILE_SIZE;
		let coords = this._scene.coordsFromWGS84(opts.x, opts.y);

		/* velikost pruhledu */
		let w = Math.round(opts.width * 0.5);
		let h = Math.round(opts.height * 0.5)

		/* vyrobit seznam dlazdic ve viewportu */
		for (let i=-w; i<w+ts; i+=ts) {
			for (let j=-h; j<h+ts; j+=ts) {
				let tile = this._pixelToTile(new ScenePixel(i, j), coords, opts.z, ts);

				if (!tile) { continue; }

				let url = this.buildURL(opts.url, tile, opts.z);
				let pos = this._tileToPixel(tile, coords, opts.z);

				tiles.push({
					tile,
					left: w + Math.round(pos.x),
					top: h + Math.round(pos.y),
					url
				});
			}
		}

		return tiles;
	};

	/**
	 * Pomoci dat dlazdice vytvori jeji url.
	 *
	 * @param  {String} mapserverUrl Mapserver
	 * @param  {Object} tile Vstupni dlazdice
	 * @param  {Number} zoom Zadany zoom
	 * @return {String}
	 */
	buildURL(mapserverUrl, tile, zoom) {
		let url = mapserverUrl + this.buildQuery(tile, zoom);
		let mapServerNumber = 1 + ((tile.x + tile.y) & 3);

		return url.replace(/#/, mapServerNumber);
	}

	/**
	 * Vytvoreni url query.
	 *
	 * @param  {Object} tile Vstupni dlazdice
	 * @param  {Number} zoom Zadany zoom
	 * @return {String}
	 */
	buildQuery(tile, zoom) {
		let world = this.getWorldSize(tile.zoom);
		let count = world.x / tile.tileSize;

		return this.formatString(TILE.QUERY, {
			zoom,
			x: this.numMod(tile.x, count),
			y:tile.y
		});
	}

	/**
	 * Format retezce, nahrady vsech polozek objektu s {value} = XYZ.
	 *
	 * @param  {String} str Vstupni retezec
	 * @param  {Object} params Objekt s klici na nahrady hodnot
	 * @return {String}
	 */
	formatString(str, params) {
		let output = str;

		for (let key in params) {
			output = output.replace(new RegExp("{" + key + "}", "g"), params[key]);
		}

		return output;
	}
}
